import "./styles.css";
import LoginForm from "./LoginForm";
import RegForm from "./RegForm";
import {useState} from "react";
import {Show} from "@chakra-ui/react";
import ResetForm from "./ResetForm";

export const Home = () => {
    const [pageState, setPageState] = useState<number>(0);
    return (
        <div className="main-container">
            <section>
                <h1 className="text-center header-main">Сервис ArmPay</h1>
            </section>
            <Show when={pageState === 0}>
                <LoginForm pageState={pageState} setPageState={setPageState}/>
            </Show>
            <Show when={pageState === 1}>
                <RegForm pageState={pageState} setPageState={setPageState}/>
            </Show>
            <Show when={pageState === 2}>
                <ResetForm pageState={pageState} setPageState={setPageState}/>
            </Show>
        </div>
    );
};